import { MatIconModule } from "@angular/material/icon";
import { Component, EventEmitter, Input, OnInit, Output, inject } from "@angular/core";

import { MatDialog } from "@angular/material/dialog";

import { CerrixConfirmationButtonComponent } from "../../cerrix-documents/cerrix-confirmation-button/cerrix-confirmation-button.component";
import { IncidentHyperlinkModel } from "../models/hyperlink-model";
import { CerrixEditHyperlinkComponent } from "../cerrix-hyperlinks-edit/cerrix-hyperlinks-edit.component";
import { EditHyperlinkPopup } from "../models/edit-hyperlink-popup.model";
import { IncidentHyperlinkTypeService } from "@app/incident/services/incident-hyperlinktype.service";
import { CerrixIconButtonComponent } from "@app/incident/components/src/lib/core/cerrix-icon-button/cerrix-icon-button.component";
import { SelectOptionModel } from "@app/incident/components/src/lib/core/models/select-option.model";

@Component({
    selector: "cerrix-hyperlinks-list",
    templateUrl: "./cerrix-hyperlinks-list.component.html",
    styleUrls: ["./cerrix-hyperlinks-list.component.scss"],
    imports: [
    MatIconModule,
    CerrixIconButtonComponent,
    CerrixConfirmationButtonComponent
],
    providers: []
})
export class CerrixHyperlinksListComponent implements OnInit {
    @Input() public hyperlinks: IncidentHyperlinkModel[];
    @Output() hyperlinksChange = new EventEmitter<IncidentHyperlinkModel[]>();

    @Input() canAdd!: boolean;
    @Input() canEdit!: boolean;
    @Input() canDelete!: boolean;
    @Input() dataUiid: string = "undefined";

    private dialog = inject(MatDialog);

    private hyperlinkService = inject(IncidentHyperlinkTypeService);
    protected hyperlinkTypes: SelectOptionModel[];

    ngOnInit(): void {
        this.hyperlinkService.getHyperlinkTypes().subscribe((hyperlinkTypes) => {
            this.hyperlinkTypes = hyperlinkTypes;
        });
    }

    protected onRemoveHyperlink(hyperlink: IncidentHyperlinkModel) {
        this.hyperlinks = this.hyperlinks.filter((d) => d !== hyperlink);
        this.hyperlinksChange.emit(this.hyperlinks);
    }

    protected onEditHyperlink(hyperlink: IncidentHyperlinkModel) {
        this.openEditHyperlinkPopup([hyperlink], !this.canEdit && !this.canAdd ? "View" : "Edit");
    }

    protected onAddHyperlink() {
        this.openEditHyperlinkPopup([], "Add");
    }

    private openEditHyperlinkPopup(
        hyperlinks: IncidentHyperlinkModel[],
        openReason: "View" | "Add" | "Edit"
    ) {
        const oldDoc = hyperlinks[0];
        const dialogInput: EditHyperlinkPopup = {
            hyperlinks,
            hyperlinkTypes: this.hyperlinkTypes,
            openReason: openReason,
            canAddHyperlink: this.canAdd,
            canEditHyperlink: this.canEdit,
        };
        let dialogRef = this.dialog.open(CerrixEditHyperlinkComponent, {
            width: "826px",
            data: dialogInput,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.length) {
                if (openReason === "Add") {
                    this.hyperlinks = [...this.hyperlinks, ...result];
                    this.hyperlinksChange.emit(this.hyperlinks);
                } else if (openReason === "Edit") {
                    this.hyperlinks = this.hyperlinks.map((d) => {
                        if (d === oldDoc) {
                            return { ...result[0], id: d.id };
                        }
                        return d;
                    });
                    this.hyperlinksChange.emit(this.hyperlinks);
                }
            }
        });
    }

    openLink(hyperlink: string) {
        if (hyperlink && hyperlink.length > 0) {
            const hasProtocol = this.checkUrl(hyperlink);
            if (hasProtocol) {
                window.open(hyperlink);
            } else {
                window.open("//" + hyperlink);
            }
        }
    }

    checkUrl(hyperlink: string): boolean {
        const regex = new RegExp("(f|ht)tp");
        if (!regex.test(hyperlink)) {
            return false;
        }
        return true;
    }
}
